import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { gql, graphql } from 'react-apollo';
import { compose } from 'redux';
import cx from 'classnames';
import {
  Button,
  Row,
  FormGroup,
  Col,
  ProgressBar,
  Label,
} from 'react-bootstrap';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { injectIntl } from 'react-intl';

import ImageUploadComponent from '../ImageUploadComponent/ImageUploadComponent';
import CommomImageDisplay from '../CommonImageDisplay/CommomImageDisplay';
import { photosShow } from '../../../helpers/photosShow';
import { homebanneruploadDir } from '../../../config';

import PictureImage from '/public/AdminIcons/default.svg'
import s from './MarketingBannerForm.css';
import cp from '../../../components/commonStyle.css';

/**
 * MarketingBannerForm - Ad Server Professional v2
 * Features: CPC/CPM Campaigns, Weighted Rotation, Premium Dashboard
 * NOTA: isEnable está DEPRECATED - usamos campaignStatus como single source of truth
 */
class MarketingBannerForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // Basic fields
      title: props.initialValues?.title || '',
      link: props.initialValues?.link || '',
      image: props.initialValues?.image || '',
      buttonText: props.initialValues?.buttonText || 'Learn More',
      id: props.initialValues?.id || null,
      // Campaign fields
      campaignType: props.initialValues?.campaignType || 'PERMANENT',
      campaignStatus: props.initialValues?.campaignStatus || 'ACTIVE',
      budgetLimit: props.initialValues?.budgetLimit || 0,
      priorityWeight: props.initialValues?.priorityWeight || 50,
      currentViews: props.initialValues?.currentViews || 0,
      currentClicks: props.initialValues?.currentClicks || 0,
      // UI state
      loading: false,
      error: null,
      success: false
    };
  }

  handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    this.setState({ [name]: type === 'checkbox' ? checked : value, success: false });
  }

  handleSubmit = async (e) => {
    e.preventDefault();
    const { title, link, image, buttonText, id, campaignType, campaignStatus, budgetLimit, priorityWeight } = this.state;
    
    try {
      this.setState({ loading: true, error: null, success: false });
      
      if (!id) {
        // Create new banner
        const { data } = await this.props.createMarketingBanner({
          variables: { 
            title, image, link, buttonText, 
            campaignType, 
            budgetLimit: parseInt(budgetLimit),
            priorityWeight: parseInt(priorityWeight)
          }
        });
        
        if (data.createMarketingBanner) {
          this.setState({ 
            id: data.createMarketingBanner.id,
            loading: false,
            success: true
          });
          // Call onSuccess callback if provided (for modal mode)
          if (this.props.onSuccess) {
            setTimeout(() => this.props.onSuccess(), 500);
          }
        }
      } else {
        // Update existing banner
        const { data } = await this.props.updateMarketingBanner({
          variables: { 
            id: parseInt(id, 10), 
            title, 
            image, 
            link, 
            buttonText,
            campaignType,
            campaignStatus,
            budgetLimit: parseInt(budgetLimit),
            priorityWeight: parseInt(priorityWeight)
          }
        });
        
        if (data.updateMarketingBanner) {
          this.setState({ 
            loading: false,
            success: true,
            currentViews: data.updateMarketingBanner.currentViews,
            currentClicks: data.updateMarketingBanner.currentClicks,
            campaignStatus: data.updateMarketingBanner.campaignStatus,
            priorityWeight: data.updateMarketingBanner.priorityWeight
          });
          // Call onSuccess callback if provided (for modal mode)
          if (this.props.onSuccess) {
            setTimeout(() => this.props.onSuccess(), 500);
          }
        }
      }
    } catch (error) {
      this.setState({ 
        error: error.message,
        loading: false,
        success: false
      });
    }
  }
  
  // Reset campaign counters
  handleResetCounters = async () => {
    const { id, title, image, link, buttonText, campaignType, budgetLimit, priorityWeight } = this.state;
    
    if (!id) return;
    if (!window.confirm('¿Estás seguro de reiniciar los contadores? Esta acción no se puede deshacer.')) return;
    
    try {
      this.setState({ loading: true });
      const { data } = await this.props.updateMarketingBanner({
        variables: { 
          id: parseInt(id, 10), 
          title, image, link, buttonText, campaignType,
          budgetLimit: parseInt(budgetLimit),
          priorityWeight: parseInt(priorityWeight),
          resetCounters: true
        }
      });
      
      if (data.updateMarketingBanner) {
        this.setState({ 
          loading: false,
          success: true,
          currentViews: 0,
          currentClicks: 0,
          campaignStatus: 'ACTIVE'
        });
      }
    } catch (error) {
      this.setState({ error: error.message, loading: false });
    }
  }
  
  // Handle status change (ACTIVE, PAUSED, COMPLETED)
  handleStatusChange = async (newStatus) => {
    const { id, title, image, link, buttonText, campaignType, budgetLimit, priorityWeight } = this.state;
    
    if (!id) return;
    
    try {
      this.setState({ loading: true });
      const { data } = await this.props.updateMarketingBanner({
        variables: { 
          id: parseInt(id, 10), 
          title, image, link, buttonText, campaignType,
          budgetLimit: parseInt(budgetLimit),
          priorityWeight: parseInt(priorityWeight),
          campaignStatus: newStatus
        }
      });
      
      if (data.updateMarketingBanner) {
        this.setState({ 
          loading: false,
          success: true,
          campaignStatus: newStatus
        });
      }
    } catch (error) {
      this.setState({ error: error.message, loading: false });
    }
  }

  success = async (file, fromServer) => {
    const fileName = fromServer.file.filename;
    this.setState({ image: fileName });
  }

  render() {
    const { 
      title, link, image, buttonText, loading, error, success,
      campaignType, campaignStatus, budgetLimit, priorityWeight, currentViews, currentClicks, id
    } = this.state;
    const { formatMessage, isModal } = this.props;
    let path = photosShow(homebanneruploadDir);
    
    // Calculate metrics
    const ctr = currentViews > 0 ? ((currentClicks / currentViews) * 100).toFixed(2) : 0;
    let budgetProgress = 0;
    if (budgetLimit > 0) {
      budgetProgress = campaignType === 'CPC' 
        ? Math.min((currentClicks / budgetLimit) * 100, 100)
        : Math.min((currentViews / budgetLimit) * 100, 100);
    }
    
    // Status badge color
    const statusColors = {
      ACTIVE: '#28a745',
      PAUSED: '#ffc107', 
      COMPLETED: '#dc3545'
    };

    // Form content wrapper based on modal mode
    const formContent = this.renderFormContent(
      title, link, image, buttonText, loading, error, success,
      campaignType, campaignStatus, budgetLimit, priorityWeight, 
      currentViews, currentClicks, id, path, ctr, budgetProgress, statusColors
    );

    // In modal mode, render simplified wrapper
    if (isModal) {
      return (
        <div style={{ padding: '24px' }}>
          {formContent}
        </div>
      );
    }

    // Full page mode
    return (
      <div className='listPhotoContainer'>
        <div className={cx(s.pagecontentWrapper, 'pagecontentWrapperRTL', 'adminPhotoUplod', 'dzInputContainer')}>
          <div className={cx(cp.adminContentPadding)}>
            <div className={s.sectionCenter}>
              <div className={cp.commonAdminBorderSection}>
                <h1 className={s.headerTitle}>🎯 Ad Server - Marketing Banner</h1>
                {formContent}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
  
  renderFormContent(title, link, image, buttonText, loading, error, success,
    campaignType, campaignStatus, budgetLimit, priorityWeight, 
    currentViews, currentClicks, id, path, ctr, budgetProgress, statusColors) {
    
    const { formatMessage, isModal } = this.props;
    
    return (
      <>
                
                {/* Campaign Stats Dashboard */}
                {id && (
                  <div style={{ 
                    background: '#f8f9fa', 
                    borderRadius: '12px', 
                    padding: '20px', 
                    marginBottom: '24px',
                    border: '1px solid #e9ecef'
                  }}>
                    <Row>
                      <Col xs={12}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
                          <h4 style={{ margin: 0, color: '#333' }}>📊 Campaign Performance</h4>
                          <span style={{ 
                            background: statusColors[campaignStatus] || '#6c757d',
                            color: 'white',
                            padding: '4px 12px',
                            borderRadius: '20px',
                            fontSize: '12px',
                            fontWeight: 'bold'
                          }}>
                            {campaignStatus}
                          </span>
                        </div>
                      </Col>
                    </Row>
                    
                    <Row>
                      {/* Views */}
                      <Col xs={6} md={3}>
                        <div style={{ textAlign: 'center', padding: '12px' }}>
                          <div style={{ fontSize: '32px', fontWeight: 'bold', color: '#0056b3' }}>
                            {currentViews.toLocaleString()}
                          </div>
                          <div style={{ color: '#6c757d', fontSize: '14px' }}>👁️ Views</div>
                        </div>
                      </Col>
                      
                      {/* Clicks */}
                      <Col xs={6} md={3}>
                        <div style={{ textAlign: 'center', padding: '12px' }}>
                          <div style={{ fontSize: '32px', fontWeight: 'bold', color: '#28a745' }}>
                            {currentClicks.toLocaleString()}
                          </div>
                          <div style={{ color: '#6c757d', fontSize: '14px' }}>👆 Clicks</div>
                        </div>
                      </Col>
                      
                      {/* CTR */}
                      <Col xs={6} md={3}>
                        <div style={{ textAlign: 'center', padding: '12px' }}>
                          <div style={{ fontSize: '32px', fontWeight: 'bold', color: '#17a2b8' }}>
                            {ctr}%
                          </div>
                          <div style={{ color: '#6c757d', fontSize: '14px' }}>📈 CTR</div>
                        </div>
                      </Col>
                      
                      {/* Budget Used */}
                      <Col xs={6} md={3}>
                        <div style={{ textAlign: 'center', padding: '12px' }}>
                          <div style={{ fontSize: '32px', fontWeight: 'bold', color: budgetProgress >= 100 ? '#dc3545' : '#ffc107' }}>
                            {budgetLimit > 0 ? `${budgetProgress.toFixed(0)}%` : '∞'}
                          </div>
                          <div style={{ color: '#6c757d', fontSize: '14px' }}>💰 Budget Used</div>
                        </div>
                      </Col>
                    </Row>
                    
                    {/* Progress Bar */}
                    {budgetLimit > 0 && (
                      <Row style={{ marginTop: '12px' }}>
                        <Col xs={12}>
                          <div style={{ marginBottom: '8px', display: 'flex', justifyContent: 'space-between' }}>
                            <span style={{ fontSize: '13px', color: '#666' }}>
                              {campaignType === 'CPC' ? `Clicks: ${currentClicks} / ${budgetLimit}` : `Views: ${currentViews} / ${budgetLimit}`}
                            </span>
                            <span style={{ fontSize: '13px', color: '#666' }}>
                              {campaignType === 'CPC' ? 'Cost Per Click' : 'Cost Per View'}
                            </span>
                          </div>
                          <div style={{ 
                            background: '#e9ecef', 
                            borderRadius: '10px', 
                            height: '20px', 
                            overflow: 'hidden' 
                          }}>
                            <div style={{ 
                              width: `${Math.min(budgetProgress, 100)}%`, 
                              background: budgetProgress >= 100 ? '#dc3545' : budgetProgress >= 80 ? '#ffc107' : '#0056b3',
                              height: '100%',
                              borderRadius: '10px',
                              transition: 'width 0.3s ease'
                            }}></div>
                          </div>
                        </Col>
                      </Row>
                    )}
                    
                    {/* Reset Button */}
                    <Row style={{ marginTop: '16px' }}>
                      <Col xs={12} style={{ textAlign: 'right' }}>
                        <Button 
                          bsStyle="warning" 
                          bsSize="small"
                          onClick={this.handleResetCounters}
                          disabled={loading}
                        >
                          🔄 Reset Counters
                        </Button>
                      </Col>
                    </Row>
                  </div>
                )}
                
                <form onSubmit={this.handleSubmit}>
                  {error && <div className={s.error}>{error}</div>}
                  {success && <div className={s.success}>Banner saved successfully!</div>}
                  
                  <FormGroup className={s.space3}>
                    <Row>
                      <Col xs={12} sm={12} md={12} lg={12}>
                        <label className={cp.labelTextNew}>Banner Image</label>
                      </Col>
                      <Col xs={12} sm={12} md={12} lg={12} className={cp.textAlignCenter}>
                        <div className={'uploadDropZoneSection'}>
                          <ImageUploadComponent
                            defaultMessage="Click or drag image to upload"
                            componentConfig={{
                              iconFiletypes: ['.jpg', '.png', '.jpeg'],
                              multiple: false,
                              showFiletypeIcon: false,
                              postUrl: '/uploadHomeBanner'
                            }}
                            loaderName={'bannerUploaderLoading'}
                            success={this.success}
                          >
                          </ImageUploadComponent>
                          <img src={PictureImage} alt={'PictureImage'} className={'uploadDropZoneSectionImage'} />
                        </div>
                        {image && (
                          <CommomImageDisplay
                            loader={loading}
                            image={path + image}
                          />
                        )}
                      </Col>
                    </Row>
                  </FormGroup>

                  <FormGroup >
                    <Row>
                      <Col xs={12} sm={12} md={12} lg={12}>
                        <label className={cp.labelTextNew}>Title</label>
                      </Col>
                      <Col xs={12} sm={12} md={12} lg={12}>
                        <input
                          type="text"
                          name="title"
                          value={title}
                          onChange={this.handleInputChange}
                          className={cx(cp.formControlInput)}
                          placeholder="Enter banner title"
                        />
                      </Col>
                    </Row>
                  </FormGroup>

                  <FormGroup className={s.space3}>
                    <Row>
                      <Col xs={12} sm={12} md={12} lg={12}>
                        <label className={cp.labelTextNew}>Link</label>
                      </Col>
                      <Col xs={12} sm={12} md={12} lg={12}>
                        <input
                          type="text"
                          name="link"
                          value={link}
                          onChange={this.handleInputChange}
                          className={cx(cp.formControlInput)}
                          placeholder="Enter banner link"
                        />
                      </Col>
                    </Row>
                  </FormGroup>

                  <FormGroup className={s.space3}>
                    <Row>
                      <Col xs={12} sm={12} md={12} lg={12}>
                        <label className={cp.labelTextNew}>Button Text</label>
                      </Col>
                      <Col xs={12} sm={12} md={12} lg={12}>
                        <input
                          type="text"
                          name="buttonText"
                          value={buttonText}
                          onChange={this.handleInputChange}
                          className={cx(cp.formControlInput)}
                          placeholder="Enter button text"
                        />
                      </Col>
                    </Row>
                  </FormGroup>

                  {/* Campaign Settings Section */}
                  <div style={{ 
                    background: '#e8f4fd', 
                    borderRadius: '12px', 
                    padding: '24px', 
                    marginBottom: '24px',
                    border: '1px solid #b8daff'
                  }}>
                    <h4 style={{ marginTop: 0, marginBottom: '20px', color: '#004085' }}>
                      ⚙️ Campaign Settings
                    </h4>
                    
                    <FormGroup className={s.space3}>
                      <Row>
                        <Col xs={12} sm={6}>
                          <label className={cp.labelTextNew}>Campaign Type</label>
                          <select
                            name="campaignType"
                            value={campaignType}
                            onChange={this.handleInputChange}
                            className={cx(cp.formControlInput)}
                            style={{ height: '42px' }}
                          >
                            <option value="PERMANENT">🔄 Permanent (Always Show)</option>
                            <option value="CPC">💰 CPC - Cost Per Click</option>
                            <option value="CPM">👁️ CPM - Cost Per View</option>
                          </select>
                        </Col>
                        <Col xs={12} sm={6}>
                          <label className={cp.labelTextNew}>
                            Budget Limit {campaignType === 'PERMANENT' && '(Not applicable)'}
                          </label>
                          <input
                            type="number"
                            name="budgetLimit"
                            value={budgetLimit}
                            onChange={this.handleInputChange}
                            className={cx(cp.formControlInput)}
                            placeholder={campaignType === 'CPC' ? 'Max clicks (e.g. 100)' : 'Max views (e.g. 1000)'}
                            disabled={campaignType === 'PERMANENT'}
                            min="0"
                          />
                        </Col>
                      </Row>
                    </FormGroup>
                    
                    {/* Priority Weight Slider */}
                    <FormGroup className={s.space3} style={{ marginTop: '20px' }}>
                      <Row>
                        <Col xs={12}>
                          <label className={cp.labelTextNew}>
                            🎯 Frecuencia de Aparición
                          </label>
                          <div style={{ 
                            display: 'flex', 
                            alignItems: 'center', 
                            gap: '16px',
                            marginTop: '8px'
                          }}>
                            <span style={{ color: '#6c757d', fontSize: '13px', minWidth: '60px' }}>
                              Baja (1)
                            </span>
                            <input
                              type="range"
                              name="priorityWeight"
                              value={priorityWeight}
                              onChange={this.handleInputChange}
                              min="1"
                              max="100"
                              style={{ 
                                flex: 1, 
                                height: '8px',
                                cursor: 'pointer',
                                accentColor: '#0056b3'
                              }}
                            />
                            <span style={{ color: '#6c757d', fontSize: '13px', minWidth: '60px' }}>
                              Alta (100)
                            </span>
                          </div>
                          <div style={{ 
                            textAlign: 'center', 
                            marginTop: '12px',
                            padding: '8px 16px',
                            background: '#f8f9fa',
                            borderRadius: '20px',
                            display: 'inline-block'
                          }}>
                            <span style={{ fontWeight: 'bold', fontSize: '18px', color: '#0056b3' }}>
                              {priorityWeight}
                            </span>
                            <span style={{ color: '#6c757d', marginLeft: '4px', fontSize: '13px' }}>
                              / 100
                            </span>
                          </div>
                          <p style={{ fontSize: '12px', color: '#6c757d', marginTop: '8px' }}>
                            💡 Mayor peso = más probabilidad de aparecer cuando hay múltiples campañas activas
                          </p>
                        </Col>
                      </Row>
                    </FormGroup>
                    
                    {campaignType !== 'PERMANENT' && (
                      <div style={{ 
                        background: '#fff3cd', 
                        borderRadius: '8px', 
                        padding: '12px 16px', 
                        fontSize: '13px',
                        color: '#856404',
                        marginTop: '16px'
                      }}>
                        ⚠️ {campaignType === 'CPC' 
                          ? `Banner will auto-stop after ${budgetLimit || '___'} clicks` 
                          : `Banner will auto-stop after ${budgetLimit || '___'} views`
                        }
                      </div>
                    )}
                  </div>

                  {/* Campaign Status Control (replaces Enable/Disable checkbox) */}
                  {id && (
                    <div style={{ 
                      background: campaignStatus === 'ACTIVE' ? '#d4edda' : campaignStatus === 'PAUSED' ? '#fff3cd' : '#f8d7da', 
                      borderRadius: '12px', 
                      padding: '20px', 
                      marginBottom: '24px',
                      border: `1px solid ${campaignStatus === 'ACTIVE' ? '#c3e6cb' : campaignStatus === 'PAUSED' ? '#ffeeba' : '#f5c6cb'}`
                    }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <div>
                          <h4 style={{ margin: 0, color: '#333' }}>
                            Estado de Campaña
                          </h4>
                          <p style={{ margin: '4px 0 0', fontSize: '13px', color: '#666' }}>
                            {campaignStatus === 'ACTIVE' && '✅ Campaña activa y visible para usuarios'}
                            {campaignStatus === 'PAUSED' && '⏸️ Campaña pausada temporalmente'}
                            {campaignStatus === 'COMPLETED' && '🏁 Presupuesto agotado - campaña finalizada'}
                          </p>
                        </div>
                        <div style={{ display: 'flex', gap: '8px' }}>
                          {campaignStatus !== 'ACTIVE' && (
                            <Button 
                              bsStyle="success" 
                              bsSize="small"
                              onClick={() => this.handleStatusChange('ACTIVE')}
                              disabled={loading}
                            >
                              ▶️ Activar
                            </Button>
                          )}
                          {campaignStatus === 'ACTIVE' && (
                            <Button 
                              bsStyle="warning" 
                              bsSize="small"
                              onClick={() => this.handleStatusChange('PAUSED')}
                              disabled={loading}
                            >
                              ⏸️ Pausar
                            </Button>
                          )}
                        </div>
                      </div>
                    </div>
                  )}

                  <FormGroup className={s.noMargin}>
                    <Row>
                      <Col xs={12} sm={12} md={12} lg={12} className={cx(cp.textAlignRight, 'textAlignLeftRTL')}>
                        <Button 
                          className={cx(cp.btnPrimary, cp.btnlarge)} 
                          type="submit" 
                          disabled={loading}
                        >
                          {loading ? 'Guardar' : id ? 'Actualizar Campaña' : 'Crear Campaña'}
                        </Button>
                      </Col>
                    </Row>
                  </FormGroup>
                </form>
        </>
    );
  }
}

MarketingBannerForm.propTypes = {
  initialValues: PropTypes.object,
  intl: PropTypes.object.isRequired,
  onSuccess: PropTypes.func,
  isModal: PropTypes.bool
};

export default compose(
  injectIntl,
  withStyles(s, cp),
  graphql(gql`
    mutation createMarketingBanner(
      $title: String!, 
      $image: String!, 
      $link: String!, 
      $buttonText: String!, 
      $campaignType: String,
      $budgetLimit: Int,
      $priorityWeight: Int
    ) {
      createMarketingBanner(
        title: $title, 
        image: $image, 
        link: $link, 
        buttonText: $buttonText, 
        campaignType: $campaignType,
        budgetLimit: $budgetLimit,
        priorityWeight: $priorityWeight
      ) {
        id
        status
        title
        image
        link
        buttonText
        campaignType
        campaignStatus
        budgetLimit
        priorityWeight
        currentViews
        currentClicks
      }
    }
  `, {
    name: 'createMarketingBanner'
  }),
  graphql(gql`
    mutation updateMarketingBanner(
      $id: Int!, 
      $title: String!, 
      $image: String!, 
      $link: String!, 
      $buttonText: String!, 
      $campaignType: String,
      $campaignStatus: String,
      $budgetLimit: Int,
      $priorityWeight: Int,
      $resetCounters: Boolean
    ) {
      updateMarketingBanner(
        id: $id, 
        title: $title, 
        image: $image, 
        link: $link, 
        buttonText: $buttonText, 
        campaignType: $campaignType,
        campaignStatus: $campaignStatus,
        budgetLimit: $budgetLimit,
        priorityWeight: $priorityWeight,
        resetCounters: $resetCounters
      ) {
        id
        status
        title
        image
        link
        buttonText
        campaignType
        campaignStatus
        budgetLimit
        priorityWeight
        currentViews
        currentClicks
        ctr
        budgetProgress
      }
    }
  `, {
    name: 'updateMarketingBanner'
  })
)(MarketingBannerForm); 